import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddUserLayer from "../components/AddUserLayer";
import { Icon } from "@iconify/react/dist/iconify.js";
import Select from 'react-select'
import { Link, useParams } from "react-router-dom";
import { API_URL } from "..";
const ViewScheduleMaintenance = () => {
    const {id} = useParams();
  const [status, setStatus] = useState(''); // 'resolved' or 'not-resolved'


  const [selectTruck, setSelectTruck] = useState({});
  const [formData, setFormData] = useState({
    service_date:'',
    service_description:'',
    cost:'',
    issueResolved:'Yes'
  });
const fetchSingleMaintenance = async () =>{
    const user = JSON.parse(localStorage.getItem('user'));
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }

       let response = await fetch(`${API_URL}/api/maintenance/records/${id}/${user.id}`, { 
         method: "GET",
         headers: headersList
       });
       let data = await response.json();
       console.log(data)
      setFormData(data)
      if(data.resolved_status === true){
        setStatus('resolved');
    }else{
        setStatus('not_now');
      }
}
React.useEffect(()=>{
  fetchSingleMaintenance()
},[1])
const clickDeleteMaintenance = async () =>{
    const user = JSON.parse(localStorage.getItem('user'));
    let headersList = {
        "Accept": "*/*",
        "Content-Type": "application/json"
       }

       let response = await fetch(`${API_URL}/api/maintenance/delete/${id}/${user.id}`, { 
         method: "DELETE",
         headers: headersList
       });
       if(response.status === 200){
        window.location.href='/maintenance-logs';
       }else{
        alert('Server Problem')
       }

}
function formatDate(dateString) {
    // Parse the date string into a Date object
    const date = new Date(dateString);

    // Define an array of month names
    const months = [
        "January", "February", "March", "April", "May", "June", 
        "July", "August", "September", "October", "November", "December"
    ];

    // Extract day, month, and year from the Date object
    const day = date.getUTCDate(); // Use getUTCDate for consistent UTC handling
    const month = months[date.getUTCMonth()]; // getUTCMonth returns zero-based index
    const year = date.getUTCFullYear();

    // Format the string
    return `${day} ${month?.slice(0,3)} ${year}`;
}

  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Edit Schedule Maintenance" />

        {/* AddUserLayer */}
        <div className="card h-100 p-0 radius-12">
          <div className="card-body p-24">
            <div className="row justify-content-start">
              <div className="col-xxl-6 col-xl-8 col-lg-10">
                
                  
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
                    <div >
                    

                      <div className="mb-20">
                        <label
                          htmlFor="assigned_to"
                          className="form-label mb-20 fw-semibold text-primary-light text-sm mb-8"
                        >
                           Truck Information
                         
                        </label>
                        <div className="row">
                            <div className="col-md-4">
                            <strong>Vehicle Info</strong>
                            <p>{formData?.truck?.name}</p>
                            </div>
                          
                           
                        </div>
                      </div>
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                        Maintenance Information
                        </label>
                      
                      </div>
                      
                      <div className="row">
                            <div className="col-md-4">
                            <strong>Service Date</strong>
                            <p>{formatDate(formData.service_date)}</p>
                            </div>
                            <div className="col-md-4">
                            <strong>Phone <i className="ph ph-info" style={{fontSize:20}} title="Person Contact for service"></i></strong>
                            <p>{formData.poc_number}</p>
                            </div>
                            <div className="col-md-4">
                                <strong>Cost</strong>
                                <p>${formData?.cost}</p>
                            </div>
                           
                        </div>
                        
                      
                    
                      <div className="mb-20">
                        <label
                          htmlFor="email"
                          className="form-label fw-semibold text-primary-light text-sm mb-8"
                        >
                          Maintenance Description
                        </label>
                        <p>{formData.issue_description}</p>
                      </div>
                
                    
                   
                    </div>
                  
                
              </div>
              <div className="col-xxl-6 col-xl-8 col-lg-10" style={{
                display:'flex',
                justifyContent:'center',
                alignItems:'center'
                
              }}> 
                
                  
                   
                    {/* Upload Image Start */}

                    {/* Upload Image End */}
          
                    <div className="stamp-container">
                        {
                            status == 'resolved' ?
                            <div className="stamp-error">Resolved</div>
                           : <div className="stamp">Not Resolved</div>

                        }
                        </div>
                    </div>
                  
                
                    <div className="col-xxl-12 col-xl-12 col-lg-12 ">
                        <Link to={`/edit-schedule-maintenance/${id}`} className="btn btn-info"><i className="ph ph-pen"></i> Edit</Link> &nbsp;&nbsp;
                        <button onClick={()=>clickDeleteMaintenance()} className="btn btn-danger"><i className="ph ph-trash"></i> Remove</button>
                    </div>
            </div>
          </div>
        </div>
      </MasterLayout>
    </>
  );
};

export default ViewScheduleMaintenance;
